import { FC, FormEventHandler } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Link, Typography } from '@mui/material';

import FilterSection from '@/components/Search/components/Filters/common/FilterSection/FilterSection';
import SelectorCard from '@/components/Search/components/Filters/common/SelectorCard/SelectorCard';
import Icon from '@/designSystem/Icon/Icon';

import messages from './messages';

type Props = {
  handleChange: FormEventHandler<HTMLDivElement>;
  isFastAnswering: boolean;
  isCertified: boolean;
  isAvailable: boolean;
};

const OtherFilter: FC<Props> = ({
  isFastAnswering,
  isCertified,
  isAvailable,
  handleChange,
}) => {
  const { formatMessage } = useIntl();

  return (
    <FilterSection title={formatMessage(messages.title)}>
      <SelectorCard
        hasValue={isCertified}
        onChange={handleChange}
        name="onlyCertifiedSherpas"
        label={
          <FormattedMessage
            {...messages.certifiedTitle}
            values={{
              icon: () => <Icon icon="certified" color="accent" />,
            }}
          />
        }
        body={<FormattedMessage {...messages.certifiedContent} />}
      >
        <Link
          data-stop-propagation="my-id-stop-propagation"
          color="supporting.blue.main"
          href="https://les-sherpas.zendesk.com/hc/fr/articles/4873568193042-Que-signifie-la-pastille-Certifiee"
          target="_blank"
        >
          <Typography variant="bodyMd" color="supporting.blue.main">
            <FormattedMessage {...messages.certifiedLink} />
          </Typography>
        </Link>
      </SelectorCard>
      <SelectorCard
        hasValue={isFastAnswering}
        onChange={handleChange}
        name="onlyAnswerFastSherpas"
        label={
          <FormattedMessage
            {...messages.answerFastTitle}
            values={{
              icon: () => <Icon icon="lightningBolt" color="attention" />,
            }}
          />
        }
        body={<FormattedMessage {...messages.answerFastContent} />}
      />
      <SelectorCard
        hasValue={isAvailable}
        onChange={handleChange}
        name="onlyAvailableSherpas"
        label={
          <FormattedMessage
            {...messages.availableTitle}
            values={{
              icon: () => <Icon icon="calendar" color="brandEmphasis" />,
            }}
          />
        }
        body={<FormattedMessage {...messages.availableContent} />}
      />
    </FilterSection>
  );
};

export default OtherFilter;
